var React = require('react');

function LogoSygnet (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.68 25.056H4.421l4.271-4.27h16.151a3.957 3.957 0 002.82-1.17 3.962 3.962 0 001.173-2.827 3.959 3.959 0 00-1.17-2.827h0a4 4 0 00-2.814-1.17h-7.951l-4.249 4.249H8.77A8.28 8.28 0 01.5 8.771 8.28 8.28 0 018.77.502h20.421l-4.27 4.27H8.77a3.98 3.98 0 00-2.823 1.17 3.986 3.986 0 00-1.173 2.827 3.986 3.986 0 001.169 2.83h0a3.987 3.987 0 002.814 1.173h7.947l4.252-4.249h3.883a8.3 8.3 0 018.23 8.224 8.225 8.225 0 01-2.391 5.861 8.222 8.222 0 01-5.837 2.451z","fill":"#fff","stroke":"rgba(0,0,0,0)","strokeMiterlimit":"10","strokeWidth":"1"}));
}

LogoSygnet.defaultProps = {"className":"logo-sygnet","viewBox":"0 0 33.573 25.556","width":"33.573","height":"25.556","preserveAspectRatio":"xMinYMid meet"};

module.exports = LogoSygnet;

LogoSygnet.default = LogoSygnet;
